import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("authenticated");
    localStorage.removeItem("authenticatedAt");
    window.location.reload();
  };

  useEffect(() => {
    const authTime = parseInt(localStorage.getItem("authenticatedAt"), 10);
    const now = Date.now();
    const oneWeekMs = 7 * 24 * 60 * 60 * 1000;

    if (!authTime || now - authTime > oneWeekMs) {
      handleLogout();
    }
  }, []);

  return (
    <footer role="contentinfo" className="bg-[#0a1233] text-white relative pt-10 pb-20 mt-0 min-h-[240px]">
      <div className="max-w-6xl mx-auto px-6 h-full flex flex-col md:flex-row items-center justify-center gap-8">
        <nav aria-label="Footer navigation">
          <ul className="space-y-2 text-base sm:text-lg text-center md:text-left mx-auto md:mx-0">
            <li>
              <button onClick={() => navigate("/about")} className="hover:underline">About</button>
            </li>
            <li>
              <button onClick={() => navigate("/projects")} className="hover:underline">Projects</button>
            </li>
            <li>
              <button onClick={() => navigate("/contact")} className="hover:underline">Contact</button>
            </li>
          </ul>
        </nav>

        <img
          src="/covepoint_footer.png"
          alt="CovePoint Development Group Logo"
          className="w-[350px] md:w-[750px] object-contain"
        />
      </div>

      <div className="absolute bottom-4 right-4">
        <button
          onClick={handleLogout}
          title="Logout"
          aria-label="Logout"
          className="w-4 h-4 bg-gray-400 rounded-full opacity-50 hover:opacity-100 cursor-pointer"
        />
      </div>

      <div className="absolute bottom-4 left-6 text-xs text-gray-400">
        ©2025 CovePoint | <a href="/privacy" className="underline text-gray-400">Privacy Policy</a>
      </div>
    </footer>
  );
}
